import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "20px"
  }
}, null, -1);

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("通过");

import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { saveEditAuditInfo } from '@/request';
export default {
  name: 'EditProductSellPointModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({});
    watch(() => props.modelValue, newVal => {
      if (newVal && props.editData) {
        let initForm = _objectSpread(_objectSpread({}, form.value), props.editData);

        form.value = initForm;
      }
    });

    function confirm() {
      const {
        supMerMaterialAuditId,
        originalBrandName,
        brandName,
        originalProdAlias,
        prodAlias,
        merIntroduction,
        salesTalk
      } = form.value;
      saveEditAuditInfo({
        supMerMaterialAuditId,
        originalBrandName,
        brandName,
        originalProdAlias,
        prodAlias,
        __repeat: true,
        __warn: true
      }, {
        params: {
          merIntroduction,
          salesTalk
        }
      }).then(data => {
        if (data.success) {
          visible.value = false;
          ElMessage({
            showClose: true,
            message: '操作成功',
            type: 'success'
          });
          emit('success');
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "编辑商品",
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_vxe_grid, {
          data: [__props.editData],
          border: true,
          columns: [{
            field: 'prodNo',
            title: '商品编码'
          }, {
            field: 'prodName',
            title: '商品名称'
          }, {
            field: 'prodSpecification',
            title: '规格',
            showOverflow: 'tooltip'
          }, {
            field: 'manufacture',
            title: '厂家'
          }]
        }, null, 8, ["data"]), _hoisted_1, _createVNode(_component_el_scrollbar, {
          height: "300px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-width": "90px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "原品牌名:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.originalBrandName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.originalBrandName = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "新品牌名:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.brandName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.brandName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "原别名:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.originalProdAlias,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.originalProdAlias = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "新别名:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.prodAlias,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.prodAlias = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              disabled: "",
              label: "原卖点:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                disabled: "",
                modelValue: form.value.originalMerIntroduction,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.originalMerIntroduction = $event),
                type: "textarea",
                autosize: {
                  minRows: 4,
                  maxRows: 6
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "新卖点:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.merIntroduction,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.merIntroduction = $event),
                type: "textarea",
                autosize: {
                  minRows: 4,
                  maxRows: 6
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "原产品优势:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                type: "textarea",
                disabled: "",
                modelValue: form.value.originalSalesTalk,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.originalSalesTalk = $event),
                autosize: {
                  minRows: 4,
                  maxRows: 6
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "新产品优势:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.salesTalk,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.salesTalk = $event),
                type: "textarea",
                autosize: {
                  minRows: 4,
                  maxRows: 6
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};